import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

const ROLES = [
  { value: 'admin', label: 'Администратор', desc: 'Полный доступ, управление командой' },
  { value: 'employee', label: 'Сотрудник', desc: 'Создание договоров, задачи, контрагенты' },
  { value: 'viewer', label: 'Наблюдатель', desc: 'Только просмотр данных' },
];

function Invite() {
  const [invites, setInvites] = useState([]);
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('employee');
  const [sent, setSent] = useState(false);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    fetchInvites();
  }, []);

  const fetchInvites = async () => {
    try {
      const res = await fetch(API + '/invites', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) {
        const d = await res.json();
        setInvites(d.invites || []);
      }
    } catch (err) { console.error(err); }
  };

  const sendInvite = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const res = await fetch(API + '/invites', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ email, role }),
      });
      if (res.ok) {
        setSent(true);
        setEmail('');
        fetchInvites();
        setTimeout(() => setSent(false), 3000);
      }
    } catch (err) { console.error(err); }
  };

  const copyInviteLink = (code) => {
    navigator.clipboard.writeText(`https://khepri.tech/invite/${code}`);
    alert('Ссылка скопирована');
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>👥 Команда</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Пригласите сотрудников — они смогут работать в Khepri вместе с вами.
      </p>

      {/* Форма приглашения */}
      <div style={{ padding: 20, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636', marginBottom: 20 }}>
        <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>Пригласить сотрудника</h3>
        <form onSubmit={sendInvite} style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 500 }}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Email сотрудника"
            required
            style={inputStyle}
          />
          <div>
            <label style={{ color: '#94A3B8', fontSize: 12, display: 'block', marginBottom: 6 }}>Роль</label>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {ROLES.map(r => (
                <button key={r.value} type="button" onClick={() => setRole(r.value)}
                  style={{ padding: '10px 16px', background: role === r.value ? '#F7DE8A' : '#0F172A', color: role === r.value ? '#0F172A' : '#94A3B8', border: '1px solid #8A6636', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: role === r.value ? 700 : 500 }}>
                  {r.label}
                </button>
              ))}
            </div>
            <p style={{ color: '#94A3B8', fontSize: 11, marginTop: 6 }}>
              {ROLES.find(r => r.value === role)?.desc}
            </p>
          </div>
          <button type="submit" style={{ padding: 14, background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 15 }}>
            ✉️ Отправить приглашение
          </button>
          {sent && <p style={{ color: '#10B981', fontWeight: 600 }}>✅ Приглашение отправлено</p>}
        </form>
      </div>

      {/* Список приглашённых */}
      {invites.length > 0 && (
        <>
          <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📋 Приглашения ({invites.length})</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {invites.map((inv) => (
              <div key={inv.id} style={{ padding: 12, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                <div>
                  <div style={{ color: '#F7DE8A', fontWeight: 600 }}>{inv.invited_email}</div>
                  <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 4 }}>
                    Роль: {ROLES.find(r => r.value === inv.role)?.label || inv.role} • Статус: {inv.status}
                  </div>
                </div>
                <button onClick={() => copyInviteLink(inv.invite_code)} style={{ padding: '8px 16px', background: '#8A6636', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
                  📋 Ссылка
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

const inputStyle = { padding: 12, background: '#0F172A', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', fontSize: 14 };

export default Invite;